<template>
  <AppLayout>
    <VFlex>
      <h1 class="primary--text mb-4">
        {{ $nt('heading') }}
      </h1>
      <VCard>
        <VTabs color="white">
          <VTab
            v-for="item in agentSettings"
            :key="item.name"
            :to="{name: item.routeName}"
          >
            {{ item.name }}
          </VTab>
        </VTabs>
        <VDivider />
        <RouterView />
      </VCard>
    </VFlex>
  </AppLayout>
</template>

<script>
export default {
  name: 'AgentSettings',
  props: [],
  computed: {
    agentSettings () {
      return [
        { name: this.$nt('agentEdit'), routeName: 'agentEdit' },
        { name: this.$nt('agentDisable'), routeName: 'agentDisable' }
      ]
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
